export default __webpack_public_path__ + "static/media/img_step_4.0e051023.svg";